import i18n from "../../i18n";

export function getContentType() {
    return Object.freeze({
        Image: {
            key: "Image",
            value: i18n.t('content-type.image')
        },
        File: {
            key: "File",
            value: i18n.t('content-type.file')
        },
        MustSell: {
            key: "MustSell",
            value: i18n.t('content-type.mustsell')
        },
        ProductGroup: {
            key: "ProductGroup",
            value: i18n.t('content-type.productgroup')
        },
        Forms: {
            key: "Survey",
            value: i18n.t('content-type.survey')
        },
        Objectives: {
            key: "Objective",
            value: i18n.t('content-type.objective')
        },
        CustomerFlag: {
            key: "CustomerFlag",
            value: i18n.t('content-type.customerflag')
        },
        PriceLists: {
            key: "PriceList",
            value: i18n.t('content-type.pricelist')
        },
        DashboardLayouts: {
            key: "DashboardLayout",
            value: i18n.t('content-type.dashboard-layout')
        }
    });
}